import React, { useEffect } from 'react';

export const useOutsideElementClick = (
  refs: React.MutableRefObject<HTMLElement | null>[],
  callback: () => void,
) => {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const isOutside = refs.every(
        ref => ref.current && !ref.current.contains(event.target as Node),
      );
      if (isOutside) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback, refs]);
};
